import { useState, useEffect } from "react";
import { useDispatch } from 'react-redux'
import { FaEdit, FaTrashAlt, FaCheckCircle, FaPlus } from "react-icons/fa";
import { AiFillSetting } from 'react-icons/ai'
import { Button } from "antd";
import styled from "styled-components";
import Swal from 'sweetalert2'

import Service from '../../service/Mgt-sensor-parameter'
import TableControl from "../../component/table/TableControl";
import FormMgtParameter from "./FormMgtParameter";
import actions from "../../redux/actions";


const ButtonAddParams = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #05BC9B;
  color : white;
  width: fit-content;
  font-size : 16px;
  height: 40px;
`

const Dot = styled.div`
    height: 16px;
    width: 16px;
    margin-right: 3px;
    background-color: ${ props => props.color ? props.color :"#bbb"};
    border-radius: 50%;
    display: inline-block;
`

export default function TableMgtStations(props) {

  const getStationStatus = (code, msg) =>{
    if(code == 1){
      return <div style={{display: 'flex', justifyContent: "center", alignItems: "center"}}><Dot color={'#25EF13'} title={msg}/>{msg}</div>
    }else if(code == 2){
      return <div style={{display: 'flex', justifyContent: "center", alignItems: "center"}}><Dot color={'#FFD02B'} title={msg}/>{msg}</div>
    }else if(code == 3){
      return <div style={{display: 'flex', justifyContent: "center", alignItems: "center"}}><Dot color={'#800020'} title={msg}/>{msg}</div>
    }else{
      return <div style={{display: 'flex', justifyContent: "center", alignItems: "center"}}><Dot color={'#333333'} title={msg}/>{msg}</div>
    }
  }
  const dispatch = useDispatch();
  const [columns, setColumns] = useState([])

  useEffect(() => {
      initColumn(props.permission) 
  }, [props.permission, props.data]);

  const onToggleAllowPublic = async (paramId, allowPublic) => {
    let result = await Service.updateAllowPublic(props.sensorId, paramId, { allowPublic })
    if (result) {
      props.fncSetData(props.data.map(item => item.id == result.id ? { ...item, allow_public: result.allow_public } : item))
    }
  }

  const onToggleOnGraph = async (paramId, onGraph) => {
    let result = await Service.updateOnGraph(props.sensorId, paramId, { onGraph })
    if (result) {
      props.fncSetData(props.data.map(item => item.id == result.id ? { ...item, on_graph: result.on_graph } : item))
    }
  }

  const onDelete = async (paramId, paramName) => {
    Swal.fire({
      icon: 'question',
      title: `ยืนยันการลบพารามิเตอร์${paramName}`,
      showCancelButton: true,
      confirmButtonText: `ยืนยัน`,
      cancelButtonText: `ยกเลิก`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let result = await Service.delete(props.sensorId, paramId)
        if (result) {
          Swal.fire({
            title: "ลบพารามิเตอร์สำเร็จ",
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          }).then(function() {
            props.fncSetData(props.data.filter(item => item.id != result.id))
          })
        }
      }
    })
  }

  const buttonCreateParams = (
    <ButtonAddParams className='btn-add-data' icon={<FaPlus className='icon-add-data' />} onClick={()=>{dispatch(actions.popup.toggleVisible(true, '', '', <FormMgtParameter permission={props.permission} sensorId={props.sensorId} />))}}>
      เพิ่มพารามิเตอร์
    </ButtonAddParams>
  )

  const initColumn = (permission) =>{
    const column = [
      { title: "ชื่อ", dataIndex: "disp_name", align: "center", className: "cn allow-search", sorter: (a, b) => a.disp_name - b.disp_name, },
      { title: "เตือนการเปลี่ยนแปลง(%)", dataIndex: "pct_change_alarm", align: "center", className: "cn allow-search", sorter: (a, b) => a.pct_change_alarm - b.pct_change_alarm, },
      { title: "min", dataIndex: "base_min", align: "center", className: "cn allow-search", sorter: (a, b) => a.base_min - b.base_min, },
      { title: "max", dataIndex: "base_max", align: "center", className: "cn allow-search", sorter: (a, b) => a.base_max - b.base_max, },
      { title: "สูตรคำนวณ", dataIndex: "eval_pattern", align: "center", className: "cn allow-search", sorter: (a, b) => a.eval_pattern - b.eval_pattern, },
      {
        title: "สถานะการเชื่อมต่อ", dataIndex: "connection_status", align: "center", className: "cn", sorter: (a, b) => a.connection_status - b.connection_status,
        render: (_, record) => (
          getStationStatus(record.connection_status, record.disp_connection)
        )
      },
      {
        title: "แสดงสาธารณะ", dataIndex: "allow_public", align: "center", className: "cn", sorter: (a, b) => a.allow_public - b.allow_public,
        render: (_, record) => (
          record.allow_public ? (
            <Button
              className="btn-record__allow-public"
              onClick={() => { onToggleAllowPublic(record.id, false) }}>
              <FaCheckCircle style={{ color: "#5FDBA7" }} />
            </Button>
          ) : (
            <Button
              className="btn-record__allow-public"
              onClick={() => { onToggleAllowPublic(record.id, true) }}>
              <FaCheckCircle style={{ color: "#EBEBE4" }} />
            </Button>
          )
        )
      },
      {
        title: "กราฟ", dataIndex: "on_graph", align: "center", className: "cn", sorter: (a, b) => a.on_graph - b.on_graph,
        render: (_, record) => (
          record.on_graph ? (
            <Button
              className="btn-record__allow-public"
              onClick={() => { onToggleOnGraph(record.id, false) }}>
              <FaCheckCircle style={{ color: "#5FDBA7" }} />
            </Button>
          ) : (
            <Button
              className="btn-record__allow-public"
              onClick={() => { onToggleOnGraph(record.id, true) }}>
              <FaCheckCircle style={{ color: "#EBEBE4" }} />
            </Button>
          )
        )
      },
    ];

    if(permission.indexOf("update") >= 0 || permission.indexOf("delete") >= 0){
      column.push({
        title: <AiFillSetting/>, dataIndex: "id", align: "center", className: "cell-id",
        render: (_, record) => (
          <> 
            {props.permission.indexOf('update') >= 0 ? ( 
            <Button className="btn-edit-data"
              onClick={() => dispatch(actions.popup.toggleVisible(true, '', '', <FormMgtParameter permission={props.permission} fncRefresh={props.fncRefresh} sensorId={props.sensorId} paramId={record.id} />))}>
              <FaEdit />
            </Button>) : (<></>)}
            {props.permission.indexOf('delete') >= 0 ? ( 
            <Button
              className="btn-delete-data"
              onClick={() => { onDelete(record.id, record.sensor_paramter_disp_name) }}>
              <FaTrashAlt  />
            </Button>) : (<></>)}
          </>
        )
      })
    }

    setColumns(column)
  }

  return (
    <TableControl
      className={
        "table-mgt-list-params" +
        (props.className ? props.className : "")
      }
      topRightButton={props.permission.indexOf('create') >= 0 ? buttonCreateParams : ''}
      rowKey={'id'}
      data={props.data}
      columns={columns}
      dataSet={1}
    />
  );
}

